import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import NotFound from '@/views/GeneralViews/NotFoundPage'

const Login = () => import('@/views/Login.vue')
const Home = () => import('@/views/Pages/Home.vue')

const Dashboard = () => import('@/views/Dashboard.vue')
const IndividualStats = () => import('@/views/IndividualStats.vue')
const PayerPerformance = () => import('@/views/PayerPerformance.vue')
const Pricing = () => import('@/views/Pricing.vue')
const Icons = () => import('@/views/Icons.vue')
const UserProfile = () => import('@/views/UserProfile.vue')
const Tables = () => import('@/views/Tables.vue')

let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [
        {
            path: '/home',
            name: 'Home',
            component: Home,
            meta: {
                noBodyBackground: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        { path: '*', component: NotFound }
    ]
};

const routes = [
    {
        path: '/',
        redirect: 'dashboard',
        component: DashboardLayout,
        children: [
            {
                path: '/dashboard',
                name: 'Company Stats',
                component: Dashboard,
                meta: { requiresAuth: true },
            },
            {
                path: '/individualStats',
                name: 'Prescriber Stats',
                component: IndividualStats,
                meta: { requiresAuth: true },
            },
            {
                path: '/payerPerformance',
                name: 'Payer Performance',
                component: PayerPerformance,
                meta: { requiresAuth: true },
            },
            {
                path: '/pricing',
                name: 'Carepoint Pricing',
                component: Pricing,
                meta: { requiresAuth: true },
            },
            {
                path: '/icons',
                name: 'icons',
                component: Icons,
                meta: { requiresAuth: true },
            },
            {
                path: '/profile',
                name: 'profile',
                component: UserProfile,
                meta: { requiresAuth: true },
            },
            {
                path: '/tables',
                name: 'tables',
                component: Tables,
                meta: { requiresAuth: true },
            }
        ]
    },
    authPages
];

export default routes;